// Styles for __name__ go here.
import styled, { createGlobalStyle } from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledNavigationTab = styled.div<{ isPremium: boolean }>`
  border: 0;
  border-top: ${props => (props?.isPremium ? '0' : `${toRem(1)}`)};
  border-bottom: ${props => (props?.isPremium ? '0' : `${toRem(1)}`)};
  border-style: solid;
  border-color: ${baseVariables.color.neutral20};
  .active {
    border-bottom: ${toRem(3)} solid #1c1c1c;
  }

  .nav-wrapper {
    width: 100%;
  }

  .nav-scroll-wrapper {
    border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral30};

    .m-standard-tab-list {
      border-bottom: none;
    }
  }

  .icon-inverse-bg {
    background-color: #f4f4f4;
    color: #1c1c1c !important;
  }
  .icon-standard-bg {
    background-color: #ffffffff;
    color: #1c1c1c !important;
  }

  .nav-arrow-container {
    position: absolute;
    top: 0;
    z-index: 1;
    height: 30px;
  }
`;

export const StyledNavigationTabMobile = styled.div<{
  showNavbar: boolean;
}>`
  height: ${props => (props?.showNavbar ? '100vh' : 'auto')};
  background-color: ${baseVariables.color.base20};

  .mobile {
    &__title-container {
      border: 0;
      border-top: ${toRem(1)};
      border-bottom: ${toRem(1)};
      border-style: solid;
      border-color: ${baseVariables.color.neutral20};
    }

    &__list-style {
      list-style-type: none;
    }

    &__list-item-style {
      padding: ${toRem(12)} 0;
      border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
    }

    &__hamburger-button {
      background: none;

      span {
        font-size: ${toRem(24)};
      }
    }
  }
`;

export const CreateNavBarOverlay = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;
